import { newGuid } from "@/assets/utils/guid";
import { PolicyConfiguration } from "../policy-configurations";
import { SeatingStrategyBase } from "../seating-strategies";
import { VenueSection } from "./venue-section";

export class VenueDetails {
  constructor(id, name, venuePortalId, shortName, locationId) {
    this.id = id ? id : newGuid();
    this.venueDetailsId = { id: this.id};
    this.name = name;
    this.venuePortalId = venuePortalId;
    this.shortName = shortName;
    this.locationId = locationId;
    this.address = undefined;
    this.description = undefined;
    this.image = undefined;
    this.logo = undefined;
    this.tags = [];
    this.legalDocuments = [];
    this.obsInfo = undefined;
    this.created = undefined;
    this.deleted = undefined;
    this.venuePolicies = [];
    this.seatingStrategies = [];
    this.bookingOnRequestOnly = false;
    this.type = undefined;
    this.startTimeOfDay = undefined;
    this.currencyInfo = undefined;
    this.timeZoneInfo = undefined;
  }

  static fromJSON(json) {
    if(!json) return undefined;

    let venue =  Object.assign(new VenueDetails(), json);
    if(venue.venuePolicies) {
      venue.venuePolicies = venue.venuePolicies.map(m => {
        return PolicyConfiguration.fromJSON(m);
      });
    }

    if(venue.seatingStrategies) {
      venue.seatingStrategies = venue.seatingStrategies.map(m => {
        return SeatingStrategyBase.fromJSON(m);
      });
    }
    return venue;
  }
}

